import axios from "axios";

// const BaseUrl = "http://localhost:7084/api/";
const BaseUrl = "https://tcentb.gunvortech.com/api/";

export const controller = {
  Purchase: "Purchase",
  User: "User",
  Auth: "Auth",
  Org: "Org",
  Outlet: "Outlet",
  Customer: "Customer",
  Category: "Category",
  Supplier: "Supplier",
  Brand: "Brand",
  Tag: "Tag",
  Product: "Product",
  Sell: "Sell",
  Inventory: "Inventory",
  PosItem: "PosItem",
  ActivityLog: "ActivityLog",
  PayMethod: "PayMethod",
  Currency: "Currency",
  Report: "Report",
  Store: "Store",
  SellReturn: "SellReturn",
  PurchReturn: "PurchReturn",
  PosDefaultCat: "PosDefaultCat",
  Register: "Register",
  UserRole: "UserRole",
  VoidSell: "VoidSell",
  QuoteSale: "QuoteSale",
};

export const action = {
  GetInvUsersByInvId: "/GetInvUsersByInvId",
  ExportInventory: "/ExportInventory",
  ExportSalesGroupByCustomer: "/ExportSalesGroupByCustomer",
  SalesGroupByCustomer: "/SalesGroupByCustomer",
  OpenRegAcc: "/OpenRegAcc",
  OpenReg: "/OpenReg",
  GetActiveReg: "/GetActiveReg",
  PostCancelCart: "/PostCancelCart",
  GetLastSell: "/GetLastSell",
  CloseRegSells: "/CloseRegSells",
  Search: "/Search",
  GetAll: "/GetAll",
  GetById: "/GetById",
  Post: "/Post",
  Put: "/Put",
  Delete: "/Delete",
  GetAuthUser: "/GetAuthUser",
  Login: "/Login",
  Logout: "/Logout",
  Forgot: "/Forgot",
  ChgPass: "/ChgPass",
  GetAllByStore: "/GetAllByStore",
  GetByStoreId: "/GetByStoreId",
  GetByStore: "/GetByStore",
  GetAllByOrg: "/GetAllByOrg",
  GetProdsByCat: "/GetProdsByCat",
  GetDefaultPosItems: "/GetDefaultPosItems",
  FindProducts: "/FindProducts",
  GetCatsByStore: "/GetCatsByStore",
  GetPosItems: "/GetPosItems",
  ChangeActiveStatus: "/ChangeActiveStatus",
  CheckUserName: "/CheckUserName",
  SellByEmployee: "/SellByEmployee",
  StoreReport: "/StoreReport",
  ProductsReport: "/ProductsReport",
  SellVolumes: "/SellVolumes",
  TopSellingProducts: "/TopSellingProducts",
  InventoryStatus: "/InventoryStatus",
  EmailInvoice: "/EmailInvoice",
  GetAllByStorePg: "/GetAllByStorePg",
  GetAllByOrgPg: "/GetAllByOrgPg",
  ExportProducts: "/ExportProducts",
  ExportSells: "/ExportSells",
  GetDefaultPosCats: "/GetDefaultPosCats",
  SetAndRemovePosCat: "/SetAndRemovePosCat",
  UpdateAccess: "/UpdateAccess",
  ResetPassword: "/ResetPassword",
  GetCstmrAccBal: "/GetCstmrAccBal",
  GetLabels: "/GetLabels",
  SearchFromPos: "/SearchFromPos",
  GetProdsByOrg: "/GetProdsByOrg",
  MinimalCloseReg: "/MinimalCloseReg",
  ExportRegReports: "/ExportRegReports",
  GetAccountsDetails: "/GetAccountsDetails",
  EmailReceipt: "/EmailReceipt",
  ExportQuoteSales: "/ExportQuoteSales",
  GetEditSale: "/GetEditSale",
  ContinueSale: "/ContinueSale",
  ValidateOpenRegister: "/ValidateOpenRegister",
  ChangeStatus: "/ChangeStatus",
  GetActiveMethods: "/GetActiveMethods",
  IsTitleExist: "/IsTitleExist",
  GetCashMethod: "/GetCashMethod",
};

export const Server = (endpoint) => {
  const url = BaseUrl + endpoint + "/";
  const get = (onComplete) =>
    axios
      .get(url, { withCredentials: true })
      .then((res) => onComplete && onComplete(res.data))
      .catch((err) => {
        onComplete && onComplete(undefined, err);
        console.error("Error: ", err);
      });

  const getById = (id, onComplete) =>
    axios
      .get(url + id, { withCredentials: true })
      .then((res) => onComplete && onComplete(res.data))
      .catch((err) => {
        onComplete && onComplete(undefined, err);
        console.error("Error: ", err);
      });

  const getByIdAngPg = (id, pageNumber, rowsPerPage, onComplete) =>
    axios
      .get(url, {
        params: { id: id, pageNumber: pageNumber, rowsPerPage: rowsPerPage },
        withCredentials: true,
      })
      .then((res) => onComplete && onComplete(res.data))
      .catch((err) => {
        onComplete && onComplete(undefined, err);
        console.error("Error: ", err);
      });

  const post = (data, onComplete) =>
    axios
      .post(url, data, { withCredentials: true })
      .then((res) => onComplete && onComplete(res.data))
      .catch((err) => {
        onComplete && onComplete(undefined, err);
        console.error("Error: ", err);
      });

  const put = (data, onComplete) =>
    axios
      .put(url, data, { withCredentials: true })
      .then((res) => onComplete && onComplete(res.data))
      .catch((err) => {
        onComplete && onComplete(undefined, err);
        console.error("Error: ", err);
      });

  const Delete = (id, onComplete) =>
    axios
      .delete(url + id, { withCredentials: true })
      .then((res) => onComplete && onComplete(res.data))
      .catch((err) => {
        onComplete && onComplete(undefined, err);
        console.error("Error: ", err);
      });

  const postFile = (data, onComplete) =>
    axios
      .post(url, data, {
        withCredentials: true,
        responseType: "blob", // Required to handle binary files like Excel
      })
      .then((res) => onComplete && onComplete(res))
      .catch((err) => {
        onComplete && onComplete(undefined, err);
        console.error("File download error:", err);
      });

  return {
    get,
    getById,
    post,
    put,
    Delete,
    getByIdAngPg,
    postFile,
  };
};
